import { createContext, ReactNode, useContext } from "react";

import { useFilterAgent } from "./filter-agent.hook";

const FilterAgentContext = createContext(
  {} as ReturnType<typeof useFilterAgent>
);
export function useFilterAgentContext() {
  return useContext(FilterAgentContext);
}

interface FilterAgentProviderProps {
  children: ReactNode;
}
export function FilterAgentProvider({
  children,
}: FilterAgentProviderProps) {
  return (
    <FilterAgentContext.Provider value={useFilterAgent()}>
      {children}
    </FilterAgentContext.Provider>
  );
}